import { Container, Box, Typography, SpeedDial, SpeedDialAction, SpeedDialIcon, ButtonGroup, Button, useMediaQuery, LinearProgress } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useNavigate } from 'react-router'
import AddIcon from '@mui/icons-material/Add'
import ListComponent from '../components/ListComponent'
import { useUtiles } from '../../../../shared/context/utilesContext'
import FilterRrhhComponent from '../components/FilterRrhhComponent'
import ListMasiveComponent from '../components/ListMasiveComponent'
import UploadIcon from '@mui/icons-material/Upload'
import FilterListIcon from '@mui/icons-material/FilterList'
import { useRrhh } from '../../../../shared/context/rrhhContext'
import { useEffect } from 'react'
import { useAbility } from '../../../../shared/context/AbilityContext'
export default function ListRrhhView() {
    const theme = useTheme()
    const navigate = useNavigate()
    const { toogleOpenSilder } = useUtiles()
    const isMobile = useMediaQuery('(max-width: 600px)')
    const { resetPersonal, loadingRrhh } = useRrhh()

    useEffect(() => {
        resetPersonal()
    }, [])

    const ability = useAbility();

    useEffect(() => {
        if(!ability.can('read', 'USERS')){
            navigate('/')
        }
    }, [ability])

    return (
        <Container maxWidth="xl" disableGutters sx={{
            padding: '0px', margin: '0px',
        }}>
            <Box sx={{
                borderRadius: '10px',
                backgroundColor: theme.palette.background.paper,
                padding: '10px 20px',
                position: 'relative'
            }}>
                <Typography variant="h6" sx={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    fontSize: '20px',
                }}>
                    Lista de Recursos Humanos
                </Typography>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                }}>

                    {!isMobile && (
                        <ButtonGroup>
                            <Button startIcon={<FilterListIcon />} onClick={() => toogleOpenSilder(<FilterRrhhComponent />, 400, 'Filtros')}>
                                Filtros
                            </Button>
                            <Button startIcon={<UploadIcon />} onClick={() => toogleOpenSilder(<ListMasiveComponent />, 600, 'Cargar Masivo')}>
                                Importar
                            </Button>
                        </ButtonGroup>)}

                    {isMobile && (
                        <Button startIcon={<FilterListIcon />} onClick={() => toogleOpenSilder(<FilterRrhhComponent />, 600, 'Filtros')} variant="outlined">
                            Filtros
                        </Button>
                    )}
                </Box>
                {
                    loadingRrhh && (
                        <LinearProgress />
                    )
                }

                <ListComponent />
                <SpeedDial
                    ariaLabel="Add"
                    sx={{ position: 'absolute', bottom: isMobile ? 80 : 30, right: 8 }}
                    icon={<AddIcon />}
                    direction="right"
                    openIcon={<AddIcon />}
                    onClick={() => navigate('/rrhh/crear')}
                />
            </Box>
        </Container>
    )
}